// This file is the WebPack Entry point for generating distributable files
import App from './App'

// Initialize the App on dom loaded
;(function () {
	let app

	// Initialize the App on dom loaded
	document.addEventListener('DOMContentLoaded', () => {
		if (app) {
			// Destroy the app if it already exists
			app.destroy()
		}
		app = new App()
	})
})()
